import { createTheme, ThemeOptions } from '@mui/material/styles';
// import { red } from '@mui/material/colors';
// import { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';

export const themeOptions: ThemeOptions = {
  palette: {
    // type: 'light',
    primary: {
      main: '#388E3C',
      light: '#6abf69',
      dark: '#00600f',
      contrastText: '#000000',
    },
    secondary: {
      main: '#4a148c',
      light: '#7c43bd',
      dark: '#12005e',
      contrastText: '#ffffff',
    },
    background: {
      paper: '#cde6bb',
    },
    divider: '#000000',
  }
};

// A custom theme for this app
const theme = createTheme(themeOptions);

export default theme;
